export const convertTimestampToFullUTCDate = (timestamp) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const date = new Date(timestamp);
  const utcString = date.toUTCString();
  const utcDate = new Date(utcString);
  const day = utcDate.getUTCDate();
  const month = months[utcDate.getUTCMonth()];
  const year = utcDate.getUTCFullYear().toString();

  let hours = utcDate.getUTCHours();
  const minutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  hours = String(hours).padStart(2, '0');

  return `${month} ${day}, ${year} - ${hours}:${minutes} ${ampm}`;
};

export const convertTimestampToUTCDate = (timestamp) => {
  const dateObj = new Date(timestamp);
  const year = dateObj.getUTCFullYear();
  const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getUTCDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const convertTimestampToLocalDateTime = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear(); // Local year
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Local month
  const day = String(date.getDate()).padStart(2, '0'); // Local day
  let hours = date.getHours(); // Local hours
  const minutes = String(date.getMinutes()).padStart(2, '0'); // Local minutes
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'
  hours = String(hours).padStart(2, '0');

  return `${month}/${day}/${year} - ${hours}:${minutes} ${ampm}`;
};

export const convertTimestampForFormControl = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const convertTimestampToDateInputValue = (timestamp) => {
  const dateObj = new Date(timestamp);
  const year = dateObj.getUTCFullYear();
  const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = dateObj.getUTCDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};
